<script lang="ts">
  import {
    Button,
    Col,
    Row,
    Nav,
    NavItem,
    NavLink,
  } from "sveltestrap"
  import TokenInput from "./TokenInput.svelte"
  import { nFormatter, txLink } from "../utils/utils"
  import { chainId, connected, selectedAccount, web3 } from "svelte-web3"
  import { ERC20ABI } from "../abis/erc20"
  import { PIL } from "../stores/constants"
  import { STAKING_ABI } from "../abis/staking"
  import WalletConnect from "./WalletConnect.svelte"
  import { CONFIG } from "../config"
  import { tokenAddress } from "../stores/store"
  import TxModal from "./TxModal.svelte"

  const TABS = {
    STAKE: { tabId: 'stake', name: 'Stake' },
    UNSTAKE: { tabId: 'unstake', name: 'Unstake' },
  }

  export let xPilUnlocked;
  export let xPilRatio;
  let currentTab = TABS.STAKE.tabId;
  let payAmount = 0;
  let pilBalance = 0;
  let isApproved = false;
  let approveDisabled = false;
  let approveModalOpen = false;
  let stakeDisabled = false;
  let stakeModalOpen = false;
  let txHash = '';

  const getPilbalance = async () => {
    if (!$connected) return 0;
    const pilContract = new $web3.eth.Contract(ERC20ABI, $tokenAddress.PIL);
    pilBalance = Number.parseFloat(await pilContract.methods.balanceOf($selectedAccount).call()) / 1e18;
    const allowance = $web3.utils.toBN(await pilContract.methods.allowance($selectedAccount, CONFIG[$chainId].STAKING_ADDRESS).call())
    isApproved = allowance.gt($web3.utils.toBN(0));
  }

  const approve = async () => {
    const pilContract = new $web3.eth.Contract(ERC20ABI, $tokenAddress.PIL);
    pilContract.methods.approve(
      CONFIG[$chainId].STAKING_ADDRESS,
      '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff'
    ).send({ from: $selectedAccount })
      .on('transactionHash', hash => {
        console.log(hash);
        txHash = hash;
        approveDisabled = true;
        approveModalOpen = true;
      })
      .on('receipt', receipt => {
        console.log(receipt);
        isApproved = true;
        approveDisabled = false;
      })
  }

  const stake = async () => {
    const stakingContract = new $web3.eth.Contract(STAKING_ABI, CONFIG[$chainId].STAKING_ADDRESS);
    const input = $web3.utils.toBN((payAmount * Math.pow(10, 18)).toLocaleString('fullwide', { useGrouping: false }));
    stakingContract.methods.enter(input).send({ from: $selectedAccount })
      .on('transactionHash', hash => {
        console.log(hash);
        txHash = hash;
        stakeDisabled = true;
        stakeModalOpen = true;
      })
      .on('receipt', receipt => {
        console.log(receipt);
        payAmount = 0;
        stakeDisabled = false;
      })
  }

  const inputPayAmount = (e: Event) => {
    if (e !== undefined) {
      const value = Number.parseInt((e.target as HTMLInputElement).value);
      if (isNaN(value)) {
        payAmount = 0;
      } else {
        payAmount = value;
      }
    }
  };

  $: if($connected) {
    getPilbalance();
  }
</script>

<Col>
  <div class="pil-nav-tabs-card">
    <Row>
      <Col>
        <Nav tabs class="pil-nav-tabs">
          {#each Object.values(TABS) as tab}
            <Col>
              <NavItem>
                <NavLink
                  class="pil-nav-link"
                  href="#"
                  on:click={() => (currentTab = tab.tabId)}
                  active={currentTab !== tab.tabId}
                >
                  <div class={currentTab === tab.tabId ? ' pil-nav-active' : ''}>
                    {tab.name}
                  </div>
                </NavLink>
              </NavItem>
            </Col>
          {/each}
        </Nav>
      </Col>
    </Row>
    {#if currentTab === 'stake'}
    <Row class="trade-section">
      <Col>
        Stake PIL
      </Col>
      <Col class="col-auto">
        <div class="token-price">1 xPil = {nFormatter(xPilRatio, 3)} PIL</div>
      </Col>
      <TokenInput
        currency={'PIL'}
        onInput={inputPayAmount}
        balance={pilBalance}
        valid={payAmount <= pilBalance}
        value={payAmount}
      />
    </Row>
    <Row class="trade-section">
      {#if !$connected}
        <WalletConnect className="trade-button">Connect to a wallet</WalletConnect>
      {:else if $connected && !isApproved}
        <Button class="trade-button" on:click={approve} disabled={approveDisabled}>Allow Pilgrim to use your PIL</Button>
        <TxModal msg="Approve transaction initiated" isOpen={approveModalOpen} txHash={txHash}/>
      {:else}
        <Button class="trade-button" disabled={true} on:click={stake}>Stake</Button>
        <TxModal msg="Stake transaction initiated" isOpen={stakeModalOpen} txHash={txHash}/>
      {/if}
    </Row>
    {:else}
      <Row class="trade-section">
      <Col>
        Unstake xPIL
      </Col>
      <Col class="col-auto">
        <div class="token-price">1 xPil = {nFormatter(xPilRatio, 3)} PIL</div>
      </Col>
      <TokenInput
        currency={'xPIL'}
        onInput={inputPayAmount}
        balance={xPilUnlocked}
        valid={payAmount <= xPilUnlocked}
        value={payAmount}
      />
      </Row>
      <Row class="trade-section">
        {#if !$connected}
          <WalletConnect className="trade-button">Connect to a wallet</WalletConnect>
        {:else}
          <Button class="trade-button">Unstake</Button>
        {/if}
      </Row>
    {/if}
  </div>
</Col>

